// Common
import { enhance, enhanceWithExperiment } from './header';
import experimentSelector from '../../../../components/experiment-selector';

// Component
import Header from '../../../../components/header/header.desktop';

// ComponentWithExperiment
import { withPlugins } from '../../../../utils/octopus';
import {
  HeaderDesktop,
  PluginOficialStoreDesktop as officialStore,
} from '../../../../components/header-with-plugins/header.desktop';
import compats from '../../../../verticals/compats/plugins/HEADER/defs/desktop';
import reviews from '../../../../verticals/reviews/plugins/HEADER/defs/desktop';

const Component = enhance(Header);

const ComponentWithExperiment = enhanceWithExperiment(withPlugins(compats, officialStore, reviews)(HeaderDesktop));

export default experimentSelector({
  experimentName: 'octopus-header-plugin',
  Component,
  ComponentWithExperiment,
});
